import React, {useCallback, useState} from 'react';
import styled from 'styled-components';
import Carousel from 'nuka-carousel';
import {Image} from '../../images';
import {CreatorFeedDetailImagesProps} from './CreatorFeedDetail.Images.molecule';
import {AccentColorOptions, AccentColorProps} from 'epic-ue-theme';
import {stopFocusOnClick} from 'epic-ue-shared';

const Styled = styled.div<{accentColor?: AccentColorOptions}>`
    ${(p) => p.theme.breakpoints.down('sm')} {
        min-width: 90vw;
    }

    .slider {
        &:focus {
            outline: none;
        }
    }
    .slider-control-bottomcenter {
        bottom: -32px !important;
    }
    .dots {
        .dot {
            cursor: pointer;
            background-color: ${(p) => p.theme.palette.neutral.silver};
            &.active {
                opacity: 1;
                background-color: ${(p) =>
                    p.accentColor
                        ? p.theme.palette.accent[p.accentColor]
                        : p.theme.palette.text.primary};
            }
            height: 10px;
            width: 10px;
            border-radius: 10px;
            display: inline-block;
            margin: 5px;
            opacity: 0.6;
        }
    }
`;

const ImageWrap = styled.div``;

export const CreatorFeedDetailCarousel = ({
    detailImages = [],
    ratio,
    accentColor
}: CreatorFeedDetailImagesProps & AccentColorProps): JSX.Element => {
    const [slideIndex, setSlideIndex] = useState(0);
    const beforeSlideCallback = useCallback(
        (_, nextIndex) => {
            setSlideIndex(nextIndex);
        },
        [setSlideIndex]
    );

    const onClickDot = useCallback(
        (index) => {
            setSlideIndex(index);
        },
        [setSlideIndex]
    );

    return (
        <Styled accentColor={accentColor}>
            <Carousel
                heightMode="max"
                easing="easeExpOut"
                dragging={true}
                disableEdgeSwiping
                framePadding={`12px 0 32px`}
                slideIndex={slideIndex}
                beforeSlide={beforeSlideCallback}
                renderCenterLeftControls={null}
                renderCenterRightControls={null}
                renderBottomCenterControls={({currentSlide}) => (
                    <div className="dots">
                        {detailImages.map((image, i) => (
                            <div
                                role="menuitem"
                                tabIndex={0}
                                className={`dot ${currentSlide === i ? 'active' : ''}`}
                                key={`dot-${i}`}
                                onClick={(e) => onClickDot(i)}
                                onMouseDown={stopFocusOnClick}
                            />
                        ))}
                    </div>
                )}>
                {detailImages.map((src, i) => (
                    <ImageWrap key={`cf-mobile-image-${i}`}>
                        <Image src={src} ratio={ratio} optMaxWidth={600} />
                    </ImageWrap>
                ))}
            </Carousel>
        </Styled>
    );
};
